var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCasa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "nest_multi_room"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_76610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_76610)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M6.60078 18.5998H13.2008V15.5998H6.60078V18.5998ZM15.0008 18.5998H17.4008V15.5998H15.0008V18.5998ZM6.60078 13.7998H9.60078V10.7998H6.60078V13.7998ZM11.4008 13.7998H17.4008V10.7998H11.4008V13.7998ZM7.82578 8.9998H16.1758L12.0008 5.8498L7.82578 8.9998ZM6.59378 20.3998C6.09845 20.3998 5.67578 20.2236 5.32578 19.8711C4.97578 19.5186 4.80078 19.0948 4.80078 18.5998V9.89981C4.80078 9.61897 4.86328 9.35297 4.98828 9.10181C5.11328 8.85047 5.29245 8.63314 5.52578 8.4498L10.9258 4.3998C11.0924 4.26647 11.2674 4.1748 11.4508 4.1248C11.6341 4.0748 11.8174 4.0498 12.0008 4.0498C12.1841 4.0498 12.3674 4.0748 12.5508 4.1248C12.7341 4.1748 12.9091 4.26647 13.0758 4.3998L18.4758 8.4498C18.7091 8.63314 18.8883 8.85047 19.0133 9.10181C19.1383 9.35297 19.2008 9.61897 19.2008 9.89981V18.5998C19.2008 19.0948 19.0245 19.5186 18.6718 19.8711C18.3191 20.2236 17.8951 20.3998 17.3998 20.3998H6.59378Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasa);
export default __webpack_public_path__ + "static/media/casa.9c251ba7d5b161df9625848058f3a3f2.svg";
export { ForwardRef as ReactComponent };